import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import format from "date-fns/format";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker-overrides.css";
import differenceInCalendarDays from "date-fns/differenceInCalendarDays";

export default function DateRangeSelector(props) {
  const initial = new Date();
  const [startDate, setStartDate] = useState(
    new Date(initial.setDate(initial.getDate() - 6))
  );
  const [endDate, setEndDate] = useState(new Date());
  const [intervalDays, setIntervalDays] = useState(null);

  const { setInterval: notifyParent } = props;
  useEffect(() => {
    if (!startDate || !endDate) return;
    let days = differenceInCalendarDays(endDate, startDate);
    const start = format(startDate, "yyyy-MM-dd");
    const end = format(endDate, "yyyy-MM-dd");
    if (start === end) days = 1;
    else if (days === 0) days = 2;
    else days = days + 1;
    notifyParent(start, end);
    setIntervalDays(days);
  }, [startDate, endDate, notifyParent]);

  const inputClass =
    "cts-date-input text-center bg-surface-100 text-white placeholder-ink-3 border border-white/15 rounded-control px-3 py-1.5 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/40";

  return (
    <div className="flex flex-wrap items-center gap-4 text-sm text-white/80">
      <label className="inline-flex items-center gap-2">
        <span className="text-ink-3">Start</span>
        <DatePicker
          className={inputClass}
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          maxDate={endDate}
        />
      </label>
      <label className="inline-flex items-center gap-2">
        <span className="text-ink-3">End</span>
        <DatePicker
          className={inputClass}
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          maxDate={new Date()}
        />
      </label>
      <span className="text-ink-3">
        Total days:{" "}
        <span className="text-primary font-semibold">{intervalDays}</span>
      </span>
    </div>
  );
}
